const WON_STAGE_KEYWORDS = [
  'win',
  'won',
  'success',
  'successful',
  'برد',
  'موفق',
];

const LOST_STAGE_KEYWORDS = [
  'lost',
  'reject',
  'rejected',
  'failed',
  'unsuccessful',
  'ناموفق',
  'باخت',
  'از دست',
];

const getStageText = (stage = {}) =>
  [
    stage.name,
    stage.title,
    stage.label,
    stage.status,
    stage.key,
    typeof stage === 'string' ? stage : null,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

export const isDealLostStage = (stage = {}) => {
  const text = getStageText(stage);
  return LOST_STAGE_KEYWORDS.some((keyword) => text.includes(keyword.toLowerCase()));
};

export const isDealWonStage = (stage = {}) => {
  if (isDealLostStage(stage)) return false;
  const text = getStageText(stage);
  return WON_STAGE_KEYWORDS.some((keyword) => text.includes(keyword.toLowerCase()));
};

export const getDealStageVisualType = (stageNameOrStage = {}) => {
  const stage = typeof stageNameOrStage === 'string'
    ? { name: stageNameOrStage }
    : stageNameOrStage;
  if (isDealWonStage(stage)) return 'won';
  if (isDealLostStage(stage)) return 'lost';
  return 'ongoing';
};
